import React from 'react'
import CicleXSvg from 'images/modules/Shared/i-circle-x.svg?raw'

export { default as CicleXUrl } from 'images/modules/Shared/i-circle-x.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: CicleXSvg}} />
)
